import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import icon from './loading@3x.png';
const spin = keyframes`
  to {
    transform: rotate(360deg);
}

`;

const Loading = styled.div<{
  size: number;
  icon?: string;
}>`
  border-radius: 50%;
  width: ${(p) => p.size / 100 + 'em'};
  height: ${(p) => p.size / 100 + 'em'};
  animation: ${spin} 1s linear infinite;
  background-image: url(${(p) => p.icon || icon});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;
type LoadingProps = {
  size: number;
  icon?: string;
  delay?: number;
  className?: string;
};

class PageLoading extends Component<
  LoadingProps,
  {
    pastDelay: boolean;
  }
> {
  static defaultProps = {
    size: 32,
  };
  constructor(props: LoadingProps) {
    super(props);
    this.state = {
      pastDelay: !props.delay,
    };
  }
  timer?: number = undefined;
  componentDidMount() {
    this.timer = setTimeout(() => {
      this.setState({
        pastDelay: true,
      });
    }, this.props.delay);
  }
  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  render() {
    const { size, icon, className } = this.props;
    const { pastDelay } = this.state;
    if (!pastDelay) {
      return null;
    }
    return <Loading className={className} icon={icon} size={size} />;
  }
}

export default PageLoading;
